import { Box, Flex, Alert, AlertIcon, AlertDescription, Text } from '@chakra-ui/react'
import { useState, useEffect } from 'react'
import ReactSelect from 'react-select'
import { useBranches, BranchType } from '@/shared/api/hooks/useBranches'
import { useBranchDispatchContext } from '@/modules/teacher/context/BranchContext'
import { getFromLocalStorage } from '@/shared/utils/localStorageHelper'
import { useAuth } from '@/shared/context/AuthContext'
import { UserTypes } from '@/shared/types/auth'

const RestrictedBranchDropdown = () => {
    const [branch, setBranch] = useState(getFromLocalStorage<BranchType>('currentBranch'))

    const dispatch = useBranchDispatchContext()
    const { branches, loading: branchLoading } = useBranches()
    const { userTypes } = useAuth()

    // Global Admins and Admin Teachers may change the branch on this page.
    const canSelectBranch =
        userTypes?.some((type) =>
            [UserTypes.IS_GLOBAL_ADMIN, UserTypes.IS_ADMIN_TEACHER].includes(type)
        ) || false

    // Initialize context from localStorage on mount
    useEffect(() => {
        const storedBranch = getFromLocalStorage<BranchType>('currentBranch')
        if (storedBranch) {
            dispatch({
                type: 'set_branch',
                currentBranch: storedBranch
            })
        }
    }, [dispatch])

    const handleBranchChange = (option: BranchType | null) => {
        if (option && canSelectBranch) {
            dispatch({
                type: 'set_branch',
                currentBranch: option
            })
            setBranch(option)
        }
    }

    return (
        <>
            <Box borderRadius={4} my={3}>
                <Flex alignItems="center" gap="2" flexWrap="wrap">
                    <ReactSelect
                        styles={{
                            control: (baseStyles) => ({
                                ...baseStyles,
                                width: '15rem'
                            })
                        }}
                        value={branch}
                        isLoading={branchLoading}
                        isSearchable={canSelectBranch}
                        isDisabled={!canSelectBranch}
                        placeholder="Select branch"
                        options={branches}
                        onChange={handleBranchChange}
                    />
                </Flex>
                {!canSelectBranch && (
                    <Text fontSize="sm" mt={2} mb={4} color="gray.500" fontStyle="italic">
                        Branch selection on this page is restricted to Global Admins and
                        Admin Teachers
                    </Text>
                )}
                {!branch?.label ? (
                    <Alert status="error" borderRadius={6} my={4} maxW={'fit-content'}>
                        <AlertIcon />
                        <AlertDescription>
                            <strong>No branch selected.</strong> You need to set branch to
                            perform actions on this page
                        </AlertDescription>
                    </Alert>
                ) : null}
            </Box>
        </>
    )
}

export default RestrictedBranchDropdown
